import React from 'react';
import globalEvents from '../const/globalEvents';

function listenChangesInScripts(WrappedComponent) {
    return class extends React.Component {

        componentDidMount() {
            window.addEventListener(globalEvents.UPDATE_SCRIPTS_PANEL, this.listenChanges, false);
        }

        componentWillUnmount() {
            window.removeEventListener(globalEvents.UPDATE_SCRIPTS_PANEL, this.listenChanges, false);
        }

        listenChanges = () => {
            this.setState({ renderTs: Date.now() });
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default listenChangesInScripts;